export const locale = {
    lang: 'ar',
    data: {
        TOOLBAR: {
            MyProfile: 'ملفي الشخسصي',
            Logout: 'تسجيل خروج'
        }
    }
};
